import { BackBar, BillDetails } from '@horof/shared';
import { Button } from 'antd';
import { Link, useParams } from 'react-router';

/** An invoice's details; paying it happens on the member's page. */
export function BillPage() {
  const { billId = '' } = useParams();
  return (
    <div className="page">
      <BackBar to="back" label="رجوع" />
      <BillDetails
        billId={billId}
        memberLink={(id) => `/member/${id}`}
        actions={({ memberId, paid }) =>
          !paid &&
          memberId && (
            <Link to={`/member/${memberId}`}>
              <Button type="primary" size="large" block>
                أداء هذه الفاتورة
              </Button>
            </Link>
          )
        }
      />
    </div>
  );
}
